var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,14.006a2.981,2.981,0,0,0-1-2.219V10A10.011,10.011,0,0,0,13,0H11A10.011,10.011,0,0,0,1,10v1.837A3.137,3.137,0,0,0,1,16.4V17a7.008,7.008,0,0,0,7,7h8a7.008,7.008,0,0,0,7-7v-.774A2.981,2.981,0,0,0,24,14.006ZM2.812,15.158a1.1,1.1,0,0,1,.282-2.152H21a1,1,0,0,1,0,2H17c-1.956,0-3.979.788-6.364,2.481a2.867,2.867,0,0,1-3.271,0c-.228-.162-.447-.331-.667-.5A7.5,7.5,0,0,0,2.812,15.158ZM3,10a8.009,8.009,0,0,1,8-8h2a8.009,8.009,0,0,1,8,8v1.006l-18,.01ZM16,22H8a4.994,4.994,0,0,1-4.975-4.755,6.24,6.24,0,0,1,2.454,1.327c.239.185.479.369.729.546a4.893,4.893,0,0,0,5.584,0A9.385,9.385,0,0,1,17,17.006h4A5,5,0,0,1,16,22ZM9,5a1,1,0,0,1,2,0A1,1,0,0,1,9,5ZM6,8A1,1,0,0,1,8,8,1,1,0,0,1,6,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.627b266e5648e13b3262def1320ea00d.svg";
export { ForwardRef as ReactComponent };